export default __webpack_public_path__ + "static/media/white-gear.ae122620.svg";